<template>
  <!-- 全部订单  项目点日订单打印 -->
  <div v-loading="loading">
    <el-row class="tac" type="flex">
      <el-col :span="24" class="layout-header">
        <div class="layout-header-logo">
          <img :src="lkdLogo" style="height: 50px;margin-top: 5px">
        </div>
        <span style="margin-right: 150px;color: white">打印预览&nbsp;&nbsp;<i class="el-icon-close" @click="back" style="color: white"></i></span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="2" :offset="4" style="margin-top: 20px">
        <h4 style="text-align: center">打印预览</h4>
      </el-col>
      <el-col :span="2" :offset="14" style="margin-top: 20px">
        <i class="el-icon-close" @click="back"></i>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="2" :offset="22">
        <el-button size="small" style="margin-right:30px;margin-bottom: 20px" type="danger" @click="printPreview()">打印
        </el-button>
      </el-col>
    </el-row>
    <div id="dailyOrderPrinting-print" style="margin: auto">
      <template v-for="item in tableData">
        <v-tax :tableData="item" :key="item.INNER_CODE" :headerData="topData" :manager="managername" :project="printName" v-if="docTypeRadioSelf == 0"
          :PROJECT_TOTAL_FEE="PROJECT_TOTAL_FEE" :TOTAL_PROJECT_REAL_FEE="TOTAL_PROJECT_REAL_FEE">
        </v-tax>
        <s-tax :tableData="item" :key="item.ORDER_DETAIL_ID" :headerData="topData" :manager="managername" :project="printName" :isRemarks="isremarks"
          :PROJECT_TOTAL_FEE="PROJECT_TOTAL_FEE" :TOTAL_PROJECT_REAL_FEE="TOTAL_PROJECT_REAL_FEE" v-else>
        </s-tax>
      </template>
    </div>
    <el-row>
      <el-col :span="2" :offset="22">
        <el-button size="small" style="margin-right:30px;margin-bottom: 20px" type="danger" @click="printPreview()">打印
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import VTax from '@/components/orderPrint/dailyOrderPrintTax.vue';
import STax from '@/components/orderPrint/dailyOrderShortTax.vue';
import date from '@/assets/common/date';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      loading: true,
      managername: sessionStorage.getItem('name'),
      tableData: [],
      topData: [],
      supplierName: sessionStorage.getItem('company'),
      PRINT_PROJECT_ID: sessionStorage.getItem('PRINT_PROJECT_ID'), // 要打印的项目点
      PRINT_DATE: sessionStorage.getItem('PRINT_DATE'), // 要打印的 日期范围
      docTypeRadioSelf: sessionStorage.getItem('dailyOrderDocTypeRadioSelf'), // 长短单子标识，0代表长单子，1代表短单子
      PRINT_WITH_PRICE: sessionStorage.getItem('PRINT_WITH_PRICE'), // 价格
      PRINT_REAL_COUNT: sessionStorage.getItem('PRINT_REAL_COUNT'), // 实收 0 不带 1 带
      printName: sessionStorage.getItem('PRINT_PROJECT_NAME'), // 项目点名称
      ASSOCIATED_PERSON: [], // 制单人
      lkdLogo: this.$util.publicLogo() || '',
      PROJECT_TOTAL_FEE: 0,
      TOTAL_PROJECT_NEED_PRICE: 0,
      isremarks: this.$route.params.remarks,
      TOTAL_PROJECT_REAL_FEE: 0,
    };
  },
  components: {
    VTax,
    STax,
  },
  created() {
    this.queryData();
  },
  methods: {
    back() {
      window.history.go(-1);
      sessionStorage.removeItem('payableName');
    },
    queryData() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 67,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGEINDEX: 0,
        PAGESIZE: 100000,
        START_DAY: date(this.PRINT_DATE, '%F'),
        END_DAY: date(this.PRINT_DATE, '%F'),
        PROJECT_ID: this.PRINT_PROJECT_ID,
      };
      http.post(params).then((result) => {
        let res = [];
        if (result.length > 0) {
          this.totalCount = result[0].TOTAL;
          this.tableData = result[0].list;
          res = result.length > 0 ? result[0].list : [];
          this.PROJECT_TOTAL_FEE = result[0].TOTAL_PROJECT_FEE; // 采购金额
          this.TOTAL_PROJECT_REAL_FEE = result[0].REAL_TOTAL_PROJECT_FEE; // 实收金额
          this.PRODUCT_FEE = result[0].TOTAL_PROJECT_FEE; // 采购金额
          this.REAL_FEE = result[0].REAL_TOTAL_PROJECT_FEE; // 实收金额
        } else {
          this.totalCount = 0;
          this.tableData = [];
        }
        for (let i = 0; i < res.length; i++) {
          res.forEach((item, index) => {
            item.ID = index + 1;
          });
        }
        this.topData.push({
          SUPPLIER_NAME: this.supplierName, // 供应商名称
          PROJECT_NAME: this.printName, // 项目点名称
          TOTAL_PROJECT_FEE: this.PRODUCT_FEE, // 预定总金额
          REAL_TOTAL_PROJECT_FEE: this.REAL_FEE, // 实际金额
          SEND_DAY: this.PRINT_DATE, // 送货日期
          SHOW_PRICE: this.PRINT_WITH_PRICE, // 0 不带价格 1 带价格
        });
        this.loading = false;
        const len = res.length;
        // 判断如果是短打印，那么一张纸显示15条数据
        if (this.docTypeRadioSelf == 0) {
          this.printLength = 30;
        } else {
          this.printLength = 15;
        }
        const n = this.printLength; // 假设每行显示4个
        const lineNum = len % n === 0 ? len / n : Math.floor((len / n) + 1);
        const data = [];
        let totalSupplierFee = 0;
        for (let i = 0; i < lineNum; i++) {
          data.push(res.slice(i * n, i * n + n));
        }
        data.forEach((item, index) => {
          totalSupplierFee = 0;
          item.forEach((itemTwo) => {
            if (this.PRINT_REAL_COUNT == 1) {
              // 1 表示带实收
              // 只要打印实收，那么显示的总金额即为项目点实收总金额
              totalSupplierFee += Math.round((Number(itemTwo.REAL_COUNT) * Number(itemTwo.PROJECT_PRICE)) * 100) / 100;
            } else {
              // 不带实收
              totalSupplierFee += Math.round((Number(itemTwo.PRODUCT_COUNT) * Number(itemTwo.PROJECT_PRICE)) * 100) / 100;
            }
          });
          item.currentPage = index + 1;
          item.totalPage = lineNum;
          item.pageFee = Math.round(totalSupplierFee * 100) / 100;
        });
        this.tableData = data;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 打印
    printPreview() {
      const subOutputRankPrint = document.getElementById('dailyOrderPrinting-print');
      const newContent = subOutputRankPrint.innerHTML;
      const oldContent = document.body.innerHTML;
      document.body.innerHTML = newContent;
      window.print();
      window.location.reload();
      document.body.innerHTML = oldContent;
      this.$router.push({ name: this.pageRouter });
      window.location.reload();
      return false;
    },
  },
};
</script>
<style scoped>
.ma img {
  width: 105px;
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}

#dailyOrderPrinting-print {
  width: 284mm;
}

@media print {
  .page-break {
    page-break-after: always;
  }
}

.layout-header {
  z-index: 10;
  position: fixed;
  width: 100%;
  background: linear-gradient(#373737, #464c5b);
  line-height: 60px;
  text-align: right;
  border-bottom: 1px solid #505664;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.layout-header-logo {
  height: 60px;
  width: 210px;
  float: left;
}

.layout-header-logo img {
  width: 90%;
  margin-right: 5%;
  height: 60px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/dailyOrderPrinting.vue